import { Slider } from './Slider';

export function About({ profile }) {
    return (
        <div className='about pt-4'>
            <h2 className='about__title'>{profile.aboutTitle}</h2>
            {profile.aboutDescription.map((aboutDescription, index) => (
                <p className='about__description' key={index}>
                    {aboutDescription}
                </p>
            ))}
            <Slider
                images={[profile.aboutImages]}
                descriptionImages={profile.aboutImagesDescription} />

            <div className='col-12 m-auto mt-4'>
                <p className=''>Sin nada más que agregar, te dejo mi Playlist favorita para programar a las 3am. 🤙</p>
                {/* Spotify */}
                <iframe
                    title='Playlist de Fernando'
                    src='https://open.spotify.com/embed/playlist/4SrIvyib5m8ZK1jhCguXFS?utm_source=generator&theme=0'
                    width='100%' height='352'
                    frameBorder='0'
                    allowFullScreen=''
                    allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
                    loading='lazy'>
                </iframe>
                {/* Apple Music */}
                {/* <iframe
                    allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
                    frameBorder="0"
                    height="352"
                    style={{
                    width: "100%",
                    maxWidth: "660px",
                    overflow: "hidden",
                    borderRadius: "10px",
                    }}
                    sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
                    src="https://embed.music.apple.com/pe/playlist/canciones-para-programar-a-las-3-am/pl.u-DdAN8l3TjV3p7z?l=en-GB"
                    title="Apple Music Playlist">    
                </iframe> */}
            </div>
            <p className='about__author mt-4'>{profile.name} {profile.lastname.charAt(0)}.</p>
            <img className='about__signature' src='/assets/nosotros/firma.png' alt='Firma del autor' />
        </div>
    );
}